import { useMutation, useQueryClient } from '@tanstack/react-query';

import { seoApi } from '../api/seo-api';

import { seoKeys } from './seo-keys';

/** The next audit reopens the issue if it is still there. */
export function useResolveSeoIssue(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (issueId: string) => seoApi.resolve(storeId, issueId),
    meta: { successMessage: 'seo:toasts.resolved' },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: seoKeys.issues(storeId) }),
  });
}

/** 202: the worker runs it; the audits list shows the run once it starts. */
export function useRunSeoAudit(storeId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => seoApi.runAudit(storeId),
    meta: { successMessage: 'seo:toasts.auditQueued' },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: seoKeys.audits(storeId) }),
  });
}
